<div class="row page-header">
    <div class="col-12">
        <h1>Pending Change Orders <small>Manage pending change orders</small></h1>
    </div>
</div>

<div [hidden]="isInitialLoading">
    <ul ngbNav [(activeId)]="activeTab" (activeIdChange)="tabChanged()" class="nav-tabs mb-3">
        @if (canViewDashboard) {
            <li [ngbNavItem]="0" [destroyOnHide]="false">
                <a ngbNavLink>Dashboard</a>
            </li>
        }
        <li [ngbNavItem]="1" [destroyOnHide]="false">
            <a ngbNavLink>Records</a>
        </li>
    </ul>

    @if (canViewDashboard) {
        <div [hidden]="!isDashboardTab">
            <app-pending-change-orders-dashboard (viewRecords)="onViewRecords($event)"></app-pending-change-orders-dashboard>
        </div>
    }

    <div [hidden]="!isRecordsTab">
        <app-pending-change-orders></app-pending-change-orders>
    </div>
</div>
